import { useState } from 'react';
import { CalendarClock } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useModuleAccess } from '@/lib/useModuleAccess';
import { scheduleDefaults, type DateRangeKey, type ReportKind } from '@/lib/reports/schedule';
import { ScheduleEditor, type ScheduleDraft } from './ScheduleEditor';

/** "Schedule" on a report page: emails this report regularly with the filters set on the page. */
export function ScheduleReportButton({
  kind,
  filters,
  dateRange,
  name,
  className = '',
}: {
  kind: ReportKind;
  /** The page's current filters. */
  filters: Record<string, unknown>;
  /** The period to suggest, when the page's dates match one. */
  dateRange?: DateRangeKey;
  name?: string;
  className?: string;
}) {
  const { session } = useModuleAccess('reporting');
  const [initial, setInitial] = useState<ScheduleDraft | null>(null);

  const open = () => {
    const defaults = scheduleDefaults(kind);
    setInitial({
      ...defaults,
      name: name ?? defaults.name,
      filters: { ...(defaults.filters as Record<string, unknown>), ...filters },
      dateRange: dateRange ?? defaults.dateRange,
      recipients: session?.user.email ? [session.user.email] : [],
    });
  };

  return (
    <>
      <Button variant="secondary" size="sm" onClick={open} className={className} title="Email this report on a schedule">
        <CalendarClock className="w-4 h-4" />
        Schedule
      </Button>
      {initial && <ScheduleEditor isOpen onClose={() => setInitial(null)} initial={initial} />}
    </>
  );
}
